/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ThumbImage_item = {
    readonly placeholder: string | null;
    readonly smallPath: string | null;
    readonly masterOrZoomPath: string | null;
    readonly " $refType": "ThumbImage_item";
};
export type ThumbImage_item$data = ThumbImage_item;
export type ThumbImage_item$key = {
    readonly " $data"?: ThumbImage_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ThumbImage_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ThumbImage_item",
  "type": "ItemPhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "masterOrZoomPath",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'd5736ccfd953da28d569abc5021e308d';
export default node;
